// src/App.jsx
import React from 'react';
import { Routes, Route } from 'react-router-dom';

import Header   from './components/Header';
import Footer   from './components/Footer';

import Home     from './pages/Home';
import About    from './pages/About';
import Services from './pages/Services';
import Language from './pages/Language';
import Industry from './pages/Industry';
import Contact from './pages/Contact';

function App() {
  return (
    <>
      <Header />

      <Routes>
        <Route path="/"         element={<Home />} />
        <Route path="/about-us" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/language" element={<Language />} />
        <Route path="/industry" element={<Industry />} />
        <Route path="/contact-us" element={<Contact />} />

      </Routes>

      <Footer />
    </>
  );
}

export default App;